module.exports = __webpack_public_path__ + "img/section5_img1_3.d4744e96.svg";